import React from 'react';

import css from './TopbarSearchForm.module.css';

const IconSearchDesktop = () => (
  <svg className={css.iconSvg} width="24" height="24" viewBox="0 0 24 24" fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M8.74112 15.5L2.99999 21.2411" stroke="#23221B" strokeLinecap="round"
          strokeLinejoin="round" />
    <circle cx="7.5" cy="7.5" r="7.5" transform="matrix(-1 0 0 1 21.2411 2)" stroke="#23221B"
            strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default IconSearchDesktop;
